export default __webpack_public_path__ + "assets/icons/package-box.96548e98.svg";